const AboutUs = () => {
  return (
    <section id="about" className="section-padding text-center">
      <div className="container mb-60">
        <h2>
          About <span className="text-light">Us</span>
        </h2>
        <p className=" lead">
          Sarentu IT Solutions Pvt. Ltd., is dedicated to crafting intelligent
          100% customised ERP solutions that go beyond traditional software.
          With a focus on automation, integration, and predictive analytics, we
          develop systems that enable companies to operate smarter, not harder.
          Our custom ERP platforms are built from the ground up, leveraging AI
          and machine learning to provide real-time insights, reduce
          bottlenecks, and enhance overall business performance. Whether you're
          a manufacturing giant or a service-based enterprise, our solutions
          adapt to your unique business DNA.
        </p>
      </div>
      <div className="container text-left">
        <h3>Our USPs</h3>
        <br />
        <div className="row">
          <div
            className="col-md-12 col-sm-12 content-box mb-sm-30 wow fadeIn"
            data-wow-delay="0.2s"
            data-wow-duration="2s"
          >
            <h5 className="features-title" style={{ fontSize: 18 }}>
              100% Customization
            </h5>
            <p style={{ fontSize: 16 }}>
              Unlike generic ERPs (SAP, Oracle), our ERP is tailored to fit
              specific business operations.
            </p>
            <br />
          </div>
          <br />
          <div
            className="col-md-12 col-sm-12 content-box mb-sm-30 wow fadeIn"
            data-wow-delay="0.4s"
            data-wow-duration="2s"
          >
            <h5 className="features-title" style={{ fontSize: 18 }}>
              Scalability & Future-Readiness
            </h5>
            <p style={{ fontSize: 16 }}>
              Designed to scale as business expands, adds branches, or changes
              workflows.
            </p>
            <br />
          </div>

          <div
            className="col-md-12 col-sm-12 content-box mb-sm-30 wow fadeIn"
            data-wow-delay="0.6s"
            data-wow-duration="2s"
          >
            <h5 className="features-title" style={{ fontSize: 18 }}>
              Enhanced Security & Compliance
            </h5>
            <p style={{ fontSize: 16 }}>
              Advanced role-based access control, encryption, and data
              protection.
            </p>
            <br />
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-12 col-offset-2 col-sm-6 content-box mb-sm-30 wow fadeIn"
            data-wow-delay="0.6s"
            data-wow-duration="2s"
          >
            <h5 className="features-title" style={{ fontSize: 18 }}>
              Automation & AI Integration
            </h5>
            <p style={{ fontSize: 16 }}>
              Automate manual workflows and use predictive analytics for smarter
              decision-making.
            </p>
            <br />
          </div>
          <div
            className="col-md-12 col-offset-2 col-sm-6 content-box mb-sm-30 wow fadeIn"
            data-wow-delay="0.6s"
            data-wow-duration="2s"
          >
            <h5 className="features-title" style={{ fontSize: 18 }}>
              Predictive Analytics & Insights
            </h5>
            <p style={{ fontSize: 16 }}>
              AI-driven forecasting helps businesses anticipate demand, sales,
              inventory needs, and potential risks.
            </p>
            <br />
          </div>
          <div
            className="col-md-12 col-offset-2 col-sm-6 content-box mb-sm-30 wow fadeIn"
            data-wow-delay="0.6s"
            data-wow-duration="2s"
          >
            <h5 className="features-title" style={{ fontSize: 18 }}>
              Real-Time Decision-Making
            </h5>
            <p style={{ fontSize: 16 }}>
              AI-based business intelligence dashboards for instant insights and
              recommendations.
            </p>
            <br />
          </div>
          <div
            className="col-md-12 col-offset-2 col-sm-6 content-box mb-sm-30 wow fadeIn"
            data-wow-delay="0.6s"
            data-wow-duration="2s"
          >
            <h5 className="features-title" style={{ fontSize: 18 }}>
              Personalized Customer Experience
            </h5>
            <p style={{ fontSize: 16 }}>
              AI-driven recommendations, automated chatbots, and customer
              behavior tracking.
            </p>
            <br />
          </div>
          <div
            className="col-md-12 col-offset-2 col-sm-6 content-box mb-sm-30 wow fadeIn"
            data-wow-delay="0.6s"
            data-wow-duration="2s"
          >
            <h5 className="features-title" style={{ fontSize: 18 }}>
              ERP Cost Considerations
            </h5>
            <p style={{ fontSize: 16 }}>
              All available ERP solutions have high recurring costs that
              increase as the company grows. But in our case, it is very cheaper
              in the long run.
            </p>
          </div>
          <div className="col-md-2"></div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
